/** Chave de `localStorage` do último aviso exibido para uma pessoa. */
export function chaveUltimoAviso(pessoaId: number): string {
  return `hub_tarefas_vencidas_ultimo_aviso_${pessoaId}`;
}

/** Data de hoje no formato `YYYY-MM-DD` (fuso local), usada como marca diária. */
export function hojeISO(agora: Date = new Date()): string {
  const ano = agora.getFullYear();
  const mes = String(agora.getMonth() + 1).padStart(2, "0");
  const dia = String(agora.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}
